export function automationFromRow(row = {}) {
  const triggers = Array.isArray(row.triggers) ? row.triggers : []
  return {
    id: String(row.id ?? ''),
    objectType: 'automation',
    title: String(row.title || 'Untitled automation'),
    description: String(row.description || ''),
    status: String(row.status || 'draft'),
    definition: row.definition ?? {},
    triggers,
  }
}

export function scheduleAutomationsFromRow(row = {}) {
  const automation = automationFromRow(row)
  return automation.triggers
    .filter((trigger) => trigger.kind?.startsWith('time.'))
    .map((trigger) => ({
      ...automation,
      id: `${automation.id}:${trigger.id}`,
      automationId: automation.id,
      triggerId: trigger.id,
      cron: trigger.config?.cron ?? null,
      timezone: trigger.config?.timezone ?? null,
      runAt: trigger.config?.run_at ?? null,
      lastFiredAt: trigger.last_fired_at ?? null,
      triggerStatus: trigger.status ?? 'draft',
      scheduleEnabled: automation.status === 'active' && trigger.status === 'active',
      spec: { goal: automation.description },
    }))
}
